import { Skeleton } from '@mui/material';
import Chart from 'react-google-charts';
import { Colors } from 'src/shared/components/styles/colors';

type StatisticsChartLineProps = {
  isLoading: boolean;
  chartData: (string | number)[][] | undefined;
};

export const StatisticsChartLine = ({ isLoading, chartData }: StatisticsChartLineProps) => {
  // Transform the memberDiffItems data

  // const headers = chartData && chartData[0];

  const options = {
    curveType: 'function',
    legend: { position: 'bottom' },
    pointSize: 3,
    chartArea: { width: '80%', height: '80%' },
    animation: {
      startup: true,
      duration: 1000,
      easing: 'out',
    },
    vAxis: {
      gridlines: {
        color: 'none',
      },
    },
    yAxis: {},
    colors: [`${Colors.ColorBox.LightBlue}`],
  };

  if (isLoading) {
    return <Skeleton variant='rectangular' animation='wave' sx={{ mr: { xs: 0, md: 3 }, height: '200px', borderRadius: 1 }} />;
  }

  return <Chart chartType='LineChart' width='100%' height='200px' data={chartData} options={options} />;
};
